package com.eladfinish.bible.contest.screens.search.usecases.engine.model

import com.eladfinish.bible.contest.screens.search.model.SearchNumberOrRoot
import com.eladfinish.bible.contest.screens.search.model.SearchSuggestion
import com.eladfinish.bible.contest.screens.search.usecases.date.DateQuery
import dev.icerock.moko.resources.desc.StringDesc

sealed interface PrepareLocalSearchRequestResult {

    data class Ready(
        val originalExpression: String,
        val normalizedRegex: String,
        val suggestions: List<SearchSuggestion> = emptyList(),
    ) : PrepareLocalSearchRequestResult

    data class Error(
        val message: StringDesc,
    ) : PrepareLocalSearchRequestResult

    data class SuggestAlternative(
        val searchSuggestion: SearchSuggestion,
    ) : PrepareLocalSearchRequestResult

    data class ExecuteSpecial(
        val searchNumberOrRoot: SearchNumberOrRoot,
        val regex: String,
        /** Set for [SearchNumberOrRoot.DATE]: the date the query was parsed into. */
        val dateQuery: DateQuery? = null,
    ) : PrepareLocalSearchRequestResult

    data class DebugMessage(
        val message: String,
    ) : PrepareLocalSearchRequestResult

    data object ToggleDebugUser : PrepareLocalSearchRequestResult
}
